import React, { useState, useEffect, useRef } from "react";
import { Container } from "reactstrap";
import {
  Button,
  Grid,
  TextField,
  Typography,
  Modal,
  IconButton,
  Box,
  Paper,
} from "@mui/material";
import axios from "axios";
import { Controller, useForm } from "react-hook-form";
import Checkbox from "@mui/material/Checkbox";
import { useNavigate } from "react-router-dom";
import Moment from "moment";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
const validationSchema = yup.object().shape({
  periodontalCondition: yup.string().required("Please Select One"),

  tonsilsEnlarged: yup.boolean().nullable().required("Please Select One"),

  bruxism: yup.boolean().nullable().required("Please Select One"),

  lockingOrLuxation: yup.boolean().nullable().required("Please Select One"),
  painOnMandibularMovement: yup
    .boolean()
    .nullable()
    .required("Please Select One"),
  smoothMovement: yup.boolean().nullable().required("Please Select One"),
  tendernessToPalpitation: yup
    .boolean()
    .nullable()
    .required("Please Select One"),
});
const DentistForm = (props) => {
  const { FormId, FormPatientId, PatientName, onFormSubmit, handleClose } =
    props;

  const fields = [
    "id",
    "patientId",
    "practiceId",
    "incisorRelationship",
    "overjetMM",
    "overbiteMM",
    "periodontalCondition",
    "tonsilsEnlarged",
    "bruxism",
    "maxLateralMovement_L_MM",
    "maxLateralMovement_R_MM",
    "maxOpeningMM",
    "maxProtrusionMM",
    "tendernessToPalpitation",
    "painOnMandibularMovement",
    "smoothMovement",
    "lockingOrLuxation",
    "epworth10Plus",
    "feelingFatigued",
    "notUsingCPAP",
    "headaches",
    "inappropriateDaytimeNapping",
    "ahI5Plus",
    "providerName",
    "providerSignature",
    "providerDate",
    "createdDate",
    "createdBy",
    "updatedDate",
    "updatedBy",
    "inactive",
  ];

  const defValues = {
    id: 0,
    patientId: 0,
    practiceId: 0,
    incisorRelationship: "",
    overjetMM: "",
    overbiteMM: "",
    periodontalCondition: "",
    tonsilsEnlarged: null,
    bruxism: null,
    maxLateralMovement_L_MM: "",
    maxLateralMovement_R_MM: "",
    maxOpeningMM: "",
    maxProtrusionMM: "",
    tendernessToPalpitation: null,
    painOnMandibularMovement: null,
    smoothMovement: null,
    lockingOrLuxation: null,
    epworth10Plus: null,
    feelingFatigued: null,
    notUsingCPAP: null,
    headaches: null,
    inappropriateDaytimeNapping: null,
    ahI5Plus: null,
    providerName: "",
    providerSignature: "",
    providerDate: "",
    createdDate: "",
    createdBy: "",
    updatedDate: "",
    updatedBy: "",
    inactive: false,
  };

  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = { Authorization: auth };

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: defValues,
  });

  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (FormId) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/PatientForms/GetFormDentistUseId?id=${FormId}`,
          { headers },
        )
        .then((response) => {
          fields.forEach((field) => {
            setValue(field, response[field]);
          });
          if (response?.providerDate) {
            setValue(
              "providerDate",
              moment(response.providerDate).format("YYYY-MM-DD"),
            );
          }
        })
        .catch((error) => {
          console.error("Error loading form data:", error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to load form data",
          });
        });
    }
  }, [FormId]);

  const onSubmit = (data) => {
    setSubmitting(true);

    const postData = {
      ...data,
      patientId: FormPatientId,
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/PatientForms/AddFormDentistUse`,
        postData,
        { headers },
      )
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Form Added!",
          html: `<p>Dental Assessment Form has been saved successfully.</p>`,
          timer: 2000, // 2 seconds
          showConfirmButton: false,
          timerProgressBar: true,
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) swalPopup.style.zIndex = 2200;
          },
        });
        if (onFormSubmit) {
          onFormSubmit(response.id);
        }

        handleClose();
        setSubmitting(false);
      })
      .catch((error) => {
        setSubmitting(false);
        Swal.fire({
          icon: "error",
          title: "Failed!",
          html: `<p>${
            error.response?.data?.message ||
            "Something went wrong. Please try again."
          }</p>`,
          confirmButtonColor: "#F44336",
          willOpen: () => {
            const swalPopup = document.querySelector(".swal2-container");
            if (swalPopup) swalPopup.style.zIndex = 2200;
          },
        });
      });
  };
  const [progressNoteDialogOpen, setProgressNoteDialogOpen] = useState(false);
  const [progressNoteContent, setProgressNoteContent] = useState("");
  const formRef = useRef(null);
  const [editorHTML, setEditorHTML] = useState("");
  const replaceInputsWithText = (container) => {
    if (!container) return;

    // Replace radios with ☑/☐
    const radios = container.querySelectorAll('input[type="radio"]');
    radios.forEach((radio) => {
      const checked = radio.checked ? "☑" : "☐";
      const span = document.createElement("span");
      span.innerHTML = `${checked}`;
      span.style.marginRight = "12px";
      span.style.display = "inline-block";
      span.style.lineHeight = "1.5"; // gives extra height
      radio.parentNode.replaceChild(span, radio);
    });

    // Replace checkboxes with ☑/☐
    const checkboxes = container.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      const checked = checkbox.checked ? "☑" : "☐";
      const span = document.createElement("span");
      span.innerHTML = `${checked}`;
      span.style.marginRight = "12px";
      span.style.display = "inline-block";
      span.style.lineHeight = "1.5"; // gives extra height
      checkbox.parentNode.replaceChild(span, checkbox);
    });

    // Replace all text/date/number inputs with bold text
    const textInputs = container.querySelectorAll(
      'input:not([type="radio"]):not([type="checkbox"])',
    );
    textInputs.forEach((input) => {
      const value = input.value || "-";
      const span = document.createElement("span");
      span.innerText = value;
      span.style.fontWeight = "bold";
      span.style.display = "inline-block";
      span.style.padding = "6px 8px"; // adds height/padding
      span.style.minWidth = "120px"; // optional: ensures spacing
      span.style.backgroundColor = "#f0f0f0"; // optional subtle background
      span.style.borderRadius = "4px";
      input.parentNode.replaceChild(span, input);
    });
  };

  const convertToProgressNote = (formData) => {
    if (!formRef.current) return;

    const formClone = formRef.current.cloneNode(true);
    replaceInputsWithText(formClone);

    const html = `
    <div
      style="
        font-family: Calibri, Segoe UI, sans-serif;
        color: #000;
        width: 100%;
        max-width: 100%;
        background: #ffffff;
        border: 1.5px solid #cfd8dc;
        border-radius: 10px;
        box-shadow: 0 4px 14px rgba(0,0,0,0.08);
        box-sizing: border-box;
        overflow-x: auto;
        padding: 10px;
      "
    >
      <div
        style="
          width: 100%;
          box-sizing: border-box;
          padding: 0;
          margin: 0;
        "
      >
        ${formClone.innerHTML}
      </div>
    </div>
  `;

    setEditorHTML(html);
    setProgressNoteDialogOpen(true);
  };

  const onSubmitProgresNote = (data) => {
    const today = new Date().toISOString().split("T")[0];
    const postData = {
      patientId: FormPatientId,
      patientNoteId: 0,
      noteText: editorHTML,
      signedDate: "",
      visitDate: today,
    };

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/PatientNote/AddPatientNote`,
        postData,
        { headers },
      )
      .then((response) => {
        setProgressNoteDialogOpen(false);
        handleClose();
        Swal.fire({
          icon: "success",
          timer: 1000,
          showConfirmButton: false,
          title: "Note saved successfully.",
          willOpen: () => {
            const container = document.querySelector(".swal2-container");
            if (container) container.style.zIndex = "1800";
          },
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: `Error ${error.message}`,
          timer: 1000,
          willOpen: () => {
            const container = document.querySelector(".swal2-container");
            if (container) container.style.zIndex = "1800";
          },
        });
      });
  };

  return (
    <>
      <Modal
        open={progressNoteDialogOpen}
        onClose={() => setProgressNoteDialogOpen(false)}
        aria-labelledby="progress-note-modal"
        sx={{
          zIndex: 1820,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
        }}
      >
        <Paper
          elevation={24}
          sx={{
            width: "98%",
            maxWidth: 1020,
            maxHeight: "95vh",
            display: "flex",
            flexDirection: "column",
            borderRadius: 3,
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              background: "linear-gradient(135deg, #2c5aa0 0%, #1976d2 100%)",
              color: "white",
              p: 1.5,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography
                variant="h5"
                fontWeight="bold"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: "#fff",
                }}
              >
                Progress Note
              </Typography>
            </Box>
            <IconButton
              onClick={() => setProgressNoteDialogOpen(false)}
              sx={{ color: "white" }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Toolbar */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
              p: 1,
              backgroundColor: "#f9f9f9",
              borderBottom: "1px solid #ddd",
            }}
          >
            {[
              { label: "B", command: "bold", style: { fontWeight: "bold" } },
              { label: "I", command: "italic", style: { fontStyle: "italic" } },
              {
                label: "U",
                command: "underline",
                style: { textDecoration: "underline" },
              },
              {
                label: "S",
                command: "strikeThrough",
                style: { textDecoration: "line-through" },
              },
              { label: "Sub", command: "subscript" },
              { label: "Sup", command: "superscript" },
              { label: "• List", command: "insertUnorderedList" },
              { label: "1. List", command: "insertOrderedList" },
              { label: "Left", command: "justifyLeft" },
              { label: "Center", command: "justifyCenter" },
              { label: "Right", command: "justifyRight" },
              { label: "Justify", command: "justifyFull" },
              { label: "H1", command: "formatBlock", value: "h1" },
              { label: "H2", command: "formatBlock", value: "h2" },
              { label: "Quote", command: "formatBlock", value: "blockquote" },
              { label: "Code", command: "formatBlock", value: "pre" },
              { label: "Link", command: "createLink", prompt: true },
              { label: "Text Color", command: "foreColor", color: "#000000" },
              { label: "BG Color", command: "hiliteColor", color: "#FFFF00" },
            ].map((btn) => (
              <Button
                key={btn.label}
                size="small"
                onMouseDown={(e) => {
                  e.preventDefault(); // prevent losing focus
                  if (btn.prompt) {
                    const url = prompt("Enter URL");
                    if (url) document.execCommand(btn.command, false, url);
                  } else if (btn.color) {
                    document.execCommand(btn.command, false, btn.color);
                  } else if (btn.value) {
                    document.execCommand(btn.command, false, btn.value);
                  } else {
                    document.execCommand(btn.command, false, null);
                  }
                }}
                sx={{
                  minWidth: 35,
                  fontWeight: "bold",
                  textTransform: "none",
                  ...btn.style,
                  border: "1px solid #ddd",
                  borderRadius: 2,
                  backgroundColor: "#fff",
                  "&:hover": {
                    backgroundColor: "#e0e0e0",
                  },
                }}
              >
                {btn.label}
              </Button>
            ))}
          </Box>

          {/* Editable content */}
          <Box
            sx={{
              overflowY: "auto",
              backgroundColor: "#fdfdfd",
            }}
          >
            <div
              contentEditable
              suppressContentEditableWarning
              style={{
                minHeight: "75vh",
                border: "1px solid #ccc",
                borderRadius: 4,
                padding: "16px",
                fontFamily: "'Calibri', 'Segoe UI', sans-serif",
                fontSize: 14,
                backgroundColor: "#fff",
                overflowY: "auto",
              }}
              dangerouslySetInnerHTML={{ __html: editorHTML }}
            />
          </Box>

          <Grid
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{
              bgcolor: "#f5f5f5",
              p: 1.5,
              borderTop: 1,
              borderColor: "divider",
              display: "flex",
            }}
          >
            <Grid item>
              <Button
                type="submit"
                variant="contained"
                onClick={onSubmitProgresNote}
                sx={{
                  minWidth: 200,
                  height: 40,
                  borderColor: "#4CAF50",
                  backgroundColor: "#4CAF50",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#4CAF50",
                    color: "white",
                    borderColor: "#4CAF50",
                  },
                }}
              >
                Save Progress Note
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={() => setProgressNoteDialogOpen(false)}
                disabled={submitting}
              >
                Close
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Modal>
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* Header Section */}
        <Box sx={{ m: 3 }} ref={formRef}>
          <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12}>
              <Typography
                variant="h4"
                align="center"
                fontWeight="bold"
                color="primary"
                gutterBottom
              >
                DENTAL ASSESSMENT FORM
              </Typography>
              <Typography variant="body1" align="center" sx={{ mb: 3 }}>
                Patient: <strong>{PatientName}</strong>
              </Typography>
            </Grid>
          </Grid>

          {/* Occlusion Section */}
          <Box
            sx={{
              backgroundColor: "#f8f9fa",
              p: 3,
              borderRadius: 2,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              mt: 3,
            }}
          >
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  color="primary"
                  gutterBottom
                >
                  Occlusion Assessment
                </Typography>
              </Grid>

              {/* Incisor Relationship */}
              <Grid item xs={6}>
                <Typography variant="body2" fontWeight="medium" gutterBottom>
                  Incisor relationship
                </Typography>
                <Controller
                  name="incisorRelationship"
                  control={control}
                  render={({ field }) => (
                    <Grid container spacing={1}>
                      {[
                        "Class 1",
                        "Class 2 Div I",
                        "Class 2 Div II",
                        "Class 3",
                      ].map((option) => (
                        <Grid item key={option}>
                          <label
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                          >
                            <input
                              type="radio"
                              value={option}
                              checked={field.value === option}
                              onClick={() => field.onChange(option)}
                              style={{ marginRight: 8 }}
                            />
                            <Typography variant="body2">{option}</Typography>
                          </label>
                        </Grid>
                      ))}
                    </Grid>
                  )}
                />
              </Grid>

              {/* Overjet and Overbite */}
              <Grid item xs={6}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Controller
                      name="overjetMM"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          label="Overjet (mm)"
                          type="number"
                          size="small"
                          fullWidth
                          variant="outlined"
                          {...field}
                          onChange={(e) =>
                            field.onChange(parseInt(e.target.value) || 0)
                          }
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Controller
                      name="overbiteMM"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          label="Overbite (mm)"
                          type="number"
                          size="small"
                          fullWidth
                          variant="outlined"
                          {...field}
                          onChange={(e) =>
                            field.onChange(parseInt(e.target.value) || 0)
                          }
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{
              backgroundColor: "#f8f9fa",
              p: 3,
              borderRadius: 2,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              mt: 1,
            }}
          >
          <Grid container >
            {/* Periodontal Condition */}
            <Grid item xs={12} md={6}>
              <Typography variant="body2" fontWeight="medium" gutterBottom>
                Periodontal condition
              </Typography>
              <Controller
                name="periodontalCondition"
                control={control}
                render={({ field }) => (
                  <Grid container spacing={1}>
                    {["Good", "Fair", "Poor"].map((option) => (
                      <Grid item key={option}>
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                        >
                          <input
                            type="radio"
                            value={option}
                            checked={field.value === option}
                            onClick={() => field.onChange(option)}
                            style={{ marginRight: 8 }}
                          />
                          <Typography variant="body2">{option}</Typography>
                        </label>
                      </Grid>
                    ))}
                  </Grid>
                )}
              />
              {errors.periodontalCondition && (
                <Typography color="error" variant="caption">
                  {errors.periodontalCondition.message}
                </Typography>
              )}
            </Grid>

            {/* Tonsils Enlarged */}
            <Grid item xs={12} md={6}>
              <Typography variant="body2" fontWeight="medium" gutterBottom>
                Tonsils - enlarged/inflamed
              </Typography>
              <Controller
                name="tonsilsEnlarged"
                control={control}
                render={({ field }) => (
                  <Grid container spacing={2}>
                    <Grid item>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="radio"
                          checked={field.value === true}
                          onClick={() => field.onChange(true)}
                          style={{ marginRight: 8 }}
                        />
                        <Typography variant="body2">Yes</Typography>
                      </label>
                    </Grid>
                    <Grid item>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="radio"
                          checked={field.value === false}
                          onChange={() => field.onChange(false)}
                          style={{ marginRight: 8 }}
                        />
                        <Typography variant="body2">No</Typography>
                      </label>
                    </Grid>
                  </Grid>
                )}
              />
              {errors.tonsilsEnlarged && (
                <Typography color="error" variant="caption">
                  {errors.tonsilsEnlarged.message}
                </Typography>
              )}
            </Grid>

            {/* Bruxism */}
            <Grid item xs={12} md={6}>
              <Typography variant="body2" fontWeight="medium" gutterBottom>
                Bruxism/clenching/grinding of teeth
              </Typography>
              <Controller
                name="bruxism"
                control={control}
                render={({ field }) => (
                  <Grid container spacing={2}>
                    <Grid item>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="radio"
                          checked={field.value === true}
                          onClick={() => field.onChange(true)}
                          style={{ marginRight: 8 }}
                        />
                        <Typography variant="body2">Yes</Typography>
                      </label>
                    </Grid>
                    <Grid item>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="radio"
                          checked={field.value === false}
                          onClick={() => field.onChange(false)}
                          style={{ marginRight: 8 }}
                        />
                        <Typography variant="body2">No</Typography>
                      </label>
                    </Grid>
                  </Grid>
                )}
              />
              {errors.bruxism && (
                <Typography color="error" variant="caption">
                  {errors.bruxism.message}
                </Typography>
              )}
            </Grid>
          </Grid>
          </Box>

           <Box
            sx={{
              backgroundColor: "#f8f9fa",
              p: 3,
              borderRadius: 2,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              mt: 1,
            }}
          >
          <Grid container>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                fontWeight="bold"
                color="primary"
                gutterBottom
              >
                TMJ Assessment
              </Typography>
            </Grid>

            {/* Max Lateral Movements */}
            <Grid item xs={12} md={6}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={4}>
                  <Typography variant="body2">Max lateral movements</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Controller
                    name="maxLateralMovement_L_MM"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        label="Left (mm)"
                        type="number"
                        size="small"
                        fullWidth
                        variant="outlined"
                        {...field}
                        onChange={(e) =>
                          field.onChange(parseInt(e.target.value) || 0)
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Controller
                    name="maxLateralMovement_R_MM"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        label="Right (mm)"
                        type="number"
                        size="small"
                        fullWidth
                        variant="outlined"
                        {...field}
                        onChange={(e) =>
                          field.onChange(parseInt(e.target.value) || 0)
                        }
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Max Opening and Protrusion */}
            <Grid item xs={12} md={6}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={6}>
                  <Controller
                    name="maxOpeningMM"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        label="Max opening (mm)"
                        type="number"
                        size="small"
                        fullWidth
                        variant="outlined"
                        {...field}
                        onChange={(e) =>
                          field.onChange(parseInt(e.target.value) || 0)
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Controller
                    name="maxProtrusionMM"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        label="Max protrusion (mm)"
                        type="number"
                        size="small"
                        fullWidth
                        variant="outlined"
                        {...field}
                        onChange={(e) =>
                          field.onChange(parseInt(e.target.value) || 0)
                        }
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* TMJ Symptoms */}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {[
                  {
                    name: "tendernessToPalpitation",
                    label: "Tenderness to palpitation",
                  },
                  {
                    name: "painOnMandibularMovement",
                    label: "Pain on mandibular movement",
                  },
                  { name: "smoothMovement", label: "Smooth movement" },
                  {
                    name: "lockingOrLuxation",
                    label: "Locking and/or luxation",
                  },
                ].map((item) => (
                  <Grid item xs={12} md={6} key={item.name}>
                    <Typography
                      variant="body2"
                      fontWeight="medium"
                      gutterBottom
                    >
                      {item.label}
                    </Typography>
                    <Controller
                      name={item.name}
                      control={control}
                      render={({ field }) => (
                        <>
                          <Grid container spacing={2}>
                            <Grid item>
                              <label
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                              >
                                <input
                                  type="radio"
                                  checked={field.value === true}
                                  onClick={() => field.onChange(true)}
                                  style={{ marginRight: 8 }}
                                />
                                <Typography variant="body2">Yes</Typography>
                              </label>
                            </Grid>
                            <Grid item>
                              <label
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                              >
                                <input
                                  type="radio"
                                  checked={field.value === false}
                                  onClick={() => field.onChange(false)}
                                  style={{ marginRight: 8 }}
                                />
                                <Typography variant="body2">No</Typography>
                              </label>
                            </Grid>
                          </Grid>
                          {errors[item.name] && (
                            <Typography color="error" variant="caption">
                              {errors[item.name]?.message}
                            </Typography>
                          )}
                        </>
                      )}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
          </Box>
  <Box
            sx={{
              backgroundColor: "#e8f4fd",
              p: 3,
              borderRadius: 2,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              mt: 1,
            }}
          >
          <Grid container>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                fontWeight="bold"
                color="primary"
                gutterBottom
              >
                CARE PATHWAY
              </Typography>
              <Typography variant="body2" sx={{ mb: 3, fontStyle: "italic" }}>
                If the following are reported, a Sleep Study should be completed
                to determine if the patient has OSA and the Informed consent
                should be completed.
              </Typography>

              <Grid container spacing={2}>
                {[
                  { name: "epworth10Plus", label: "Epworth of 10+" },
                  { name: "feelingFatigued", label: "Feeling fatigued" },
                  { name: "notUsingCPAP", label: "Not using CPAP" },
                  { name: "headaches", label: "Headaches" },
                  {
                    name: "inappropriateDaytimeNapping",
                    label:
                      "Inappropriate daytime napping (e.g., during driving, conversation, or eating)",
                  },
                  {
                    name: "ahI5Plus",
                    label:
                      "AHI of 5 or above (only if the patient has already had a sleep test in the past)",
                  },
                ].map((item) => (
                  <Grid item xs={12} key={item.name}>
                    <Controller
  name={item.name}
  control={control}
  render={({ field }) => (
    <label
      style={{
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        gap: "8px",
        lineHeight: "1.4",
      }}
    >
      <input
        type="checkbox"
  checked={field.value || false} onClick={(e) => field.onChange(!field.value)}
        style={{
          width: "18px",
          height: "18px",
          margin: 0,
          flexShrink: 0,
          cursor: "pointer",
        }}
      />

      <Typography
        variant="body2"
        sx={{
          lineHeight: 1.4,
          userSelect: "none",
        }}
      >
        {item.label}
      </Typography>
    </label>
  )}
/>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
          </Box>

         <Box
            sx={{
              backgroundColor: "#f8f9fa",
              p: 3,
              borderRadius: 2,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              mt: 1,
            }}
          >
          <Grid container>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                fontWeight="bold"
                color="primary"
                gutterBottom
              >
                Provider Information
              </Typography>
            </Grid>

            <Grid item xs={12} md={4}>
              <Controller
                name="providerName"
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Provider Name"
                    size="small"
                    fullWidth
                    variant="outlined"
                    {...field}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Controller
                name="providerSignature"
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Provider Signature"
                    size="small"
                    fullWidth
                    variant="outlined"
                    {...field}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Controller
                name="providerDate"
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Date"
                    type="date"
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    {...field}
                    value={field.value || ""}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Box>
        </Box>
        {/* Submit Button */}
        <Grid
          container
          justifyContent="flex-end"
          alignItems="center"
          spacing={2}
          sx={{ mt: 4 }}
        >
          {FormId > 0 && (
            <Grid item>
              <Button
                variant="contained"
                onClick={handleSubmit((data) => convertToProgressNote(data))}
                disabled={submitting}
                sx={{
                  minWidth: 220,
                  height: 42,
                  backgroundColor: "#4CAF50",
                  color: "#fff",
                  borderRadius: "8px",
                  textTransform: "none",
                  fontWeight: 600,
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "#43A047",
                    boxShadow: "none",
                  },
                }}
              >
                Convert to Progress Note
              </Button>
            </Grid>
          )}

          <Grid item>
            <Button
              type="submit"
              variant="contained"
              disabled={submitting}
              sx={{
                minWidth: 120,
                height: 42,
                backgroundColor: "#A574FD",
                color: "#fff",
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 600,
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#8A5CE6",
                  boxShadow: "none",
                },
              }}
            >
              {submitting ? "Saving..." : "Save"}
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default DentistForm;
